const profiling = {
  private: "/BFPEDirectorProfiling/v1",
  public: "/BFPEDirectorProfiling/public/v1",
}
const services = {
  private: "/BFPEDirectorServices/v1",
  public: "/BFPEDirectorServices/public/v1",
}

const translatorApi = "/translatorApi";

export const api = {
  auth: {
    publicKey: "oauth/key",
    token: "/oauth/token",
    status: `${ profiling.private }/userLoginStatus`,
    logout: `${ profiling.private }/logout`
  },
  account: {
    create: {
      getCompanyData: `${ services.public }/enterpriseCustomerInformation/?enterpriseCustomerId=`, 
      verifyCompany: `${ profiling.public }/verifyInstitutionWithNotExecutiveExist`,
      account: `${ profiling.public }/insertSystemUserAdminExtranet`,
      generateToken: `${ profiling.public }/singleSelectTokenSms`,
      verifyToken: `${ profiling.public }/verifyTokenSmsVU`,
      password: `${ profiling.public }/modifySystemUserPasswordExtranet`,
    },
  },
  requests: {
    getRequestHistory: `${ services.private }/solicitudesHistorico`,
    getRequestByNumber: `${ services.private }/solicitud`,
    createRequest: `${ services.private }/solicitud`,
    updateRequestState: `${ services.private }/solicitud?ID=`,
    download: `${ services.private }/plantilla`,
    payment: `${ services.private }/desembolsos`,
    receipts: {
      create: `${ services.private }/comprobantes`,
      update: `${ services.private }/comprobantes`,
      delete: `${ services.private }/comprobantes?DocumentoID=`,
      pdf: `${ services.private }/comprobante?documentid=`,
      bankList: `${ profiling.private }/massiveSelectBankInstitution`
    }
  },
  users: {
    getUsers: `${ profiling.private }/massiveSelectSystemUserInstitutionJson`,
    getRoles: `${ profiling.private }/massiveSelectRoleTypeJson`,
    getEmails: `${ profiling.private }/listElectronicsContactByRoleType`,
    insert: `${ profiling.private }/insertSystemUserInstitutionByAlias`,
    update: `${ profiling.private }/modifySystemUserInstitutionJson`,
    delete: `${ profiling.private }/deleteSystemUserInstitutionJson`,
    email: `${ profiling.public }/processEmailNotification`,
  },
  translator: {
    getIdentificationTypes: `${ translatorApi }/textTranslation?name=identificationType&unpaged=false`,
  },
};
